module.exports = __webpack_public_path__ + "img/user.b32cc52d.png";